import styled from 'styled-components'

import { sv } from '@ucheba/utils/helpers/styles/variables'

import { Box } from '@ucheba/ui/components/Box/desktop'

export const BoxStyled = styled(Box)`
  width: 288px;
  position: absolute;
  right: 0;
  margin-top: 8px;
  z-index: 10;

  border-radius: 4px;
  box-shadow:
    0 15px 20px 0 rgba(3, 15, 35, 0.1),
    0 0 10px 0 ${sv.color.gray5};
`

export const BoxTouch = styled(BoxStyled)`
  width: unset;
  max-width: 720px;
  left: 8px;
  right: 8px;
  bottom: 64px;
  margin-left: auto;
  margin-right: auto;
  position: fixed;
  animation-duration: 300ms;
  animation-name: show;

  @keyframes show {
    from {
      bottom: -300px;
    }

    to {
      bottom: 64px;
    }
  }
`

export const Scroll = styled.span`
  position: relative;
  display: inline-flex;
  column-gap: 4px;

  cursor: pointer;
  color: rgba(29, 138, 254, 1);

  svg {
    position: absolute;
    width: 16px;
    height: 16px;
    top: 4px;
  }

  span {
    margin-left: 20px;
  }
`

export const Text = styled.div`
  text-align: left;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
`
